// Shared types and enums for workflow components
export enum WorkflowCanvasMode {
  VIEW = 'view',
  EDIT = 'edit',
  EXECUTE = 'execute'
}

// Node type definitions
export enum WorkflowNodeType {
  PHASE = 'phase',
  TOOL = 'tool',
  PERSONA = 'persona',
  ARTIFACT = 'artifact'
}

// Connection type definitions
export enum ConnectionType {
  FLOW = 'flow',
  TOOL_ASSIGNMENT = 'tool_assignment',
  PERSONA_ASSIGNMENT = 'persona_assignment',
  INPUT_ARTIFACT = 'input_artifact',
  OUTPUT_ARTIFACT = 'output_artifact'
}
